export const XSTATE_DEBUG_ENABLED = JSON.parse(process.env.MIX_XSTATE_DEBUG || "false");
export const APOLLO_DEV_TOOLS = JSON.parse(process.env.MIX_APOLLO_DEV_TOOLS || "false");
export const GRAPHQL_URI = process.env.MIX_GRAPHQL_ENDPOINT;
